/** Cost sheets saved on the server (per user). Open one, or delete it. */
import { useEffect, useState } from "react";
import { useStore } from "../../store.ts";
import { okToReplace } from "../../shared/unsaved.ts";
import { useT } from "../../shared/i18n.ts";
import { api, type SheetSummary } from "../../shared/api.ts";
import { Modal } from "../../shared/ui/common.tsx";
import { localTime } from "../../shared/time.ts";

export function MySheets() {
  const t = useT();
  const { closeModal, setSheet, go, toast } = useStore.getState();
  const current = useStore((s) => s.sheetId);
  const [q, setQ] = useState("");
  const [items, setItems] = useState<SheetSummary[] | null>(null);
  const load = () => api.sheets(q).then((r) => setItems(r.items)).catch((e) => toast(String(e.message || e)));
  useEffect(() => { const tm = setTimeout(load, 200); return () => clearTimeout(tm); }, [q]); // eslint-disable-line react-hooks/exhaustive-deps

  async function open(id: string) {
    if (!okToReplace()) return; // also when it is one's own other sheet (JF 2026-10-13)
    const r = await api.sheet(id);
    setSheet(r.data, { id: r.id }); useStore.getState().markSaved(r.data); closeModal(); go("sheet");
  }
  async function applyAsNew(id: string) {
    const r = await api.sheet(id);
    setSheet(r.data, { id: null }); closeModal(); go("sheet");
    toast(t("Saved Cost Sheet applied. Edit it and save as a new version.", "已应用保存的 Cost Sheet，修改后可另存为新记录。"));
  }
  async function del(x: SheetSummary) {
    if (!confirm(t(`Delete "${x.title || x.styleNo || x.id}"? This cannot be undone.`, `删除「${x.title || x.styleNo || x.id}」？删除后无法恢复。`))) return;
    await api.deleteSheet(x.id);
    if (x.id === current) setSheet(useStore.getState().sheet, { id: null });
    load();
  }
  return (
    <Modal onClose={closeModal} wide>
      <h3>{t("My cost sheets", "我的 cost sheet")}</h3>
      <div className="fl" style={{ marginBottom: 10 }}><input className="in" value={q} onChange={(e) => setQ(e.target.value)} placeholder={t("Search style no. / customer / name", "搜索款号 / 客户 / 款名")} /></div>
      <div className="slist">
        {items && !items.length && <div className="dim">{t("Nothing saved yet — use “Save to server” on a cost sheet.", "还没有保存的——在 cost sheet 上点「保存到服务器」。")}</div>}
        {!!items?.length && <table className="t"><tbody>
          <tr><th>{t("Saved version name", "保存名称")}</th><th>{t("Style no.", "款号")}</th><th>{t("Customer", "客户")}</th><th className="n">Actual FOB</th><th className="n">{t("Qty", "数量")}</th><th>{t("Factory / origin", "工厂 / 产地")}</th><th>{t("Saved", "保存时间")}</th><th>{t("Actions", "操作")}</th></tr>
          {items.map((x) => (
            <tr className="rec" key={x.id}>
              <td><b>{x.title || "—"}</b>{x.id === current && <span className="dim"> · {t("open now", "当前")}</span>}</td>
              <td className="mono">{x.styleNo || "—"}</td><td>{x.customer || "—"}</td>
              <td className="n mono">${Number(x.totalFobActual ?? 0).toFixed(2)}</td><td className="n mono">{x.quantity || "—"}</td>
              <td>{[x.factory, x.originCountry].filter(Boolean).join(" / ") || "—"}</td><td>{localTime(x.updatedAt)}</td>
              <td style={{ whiteSpace: "nowrap" }}><button className="btn sm" onClick={() => open(x.id)}>{t("Open", "打开")}</button>{" "}
                <button className="btn sm" onClick={() => applyAsNew(x.id)}>{t("Use as new", "应用为新")}</button>{" "}
                <button className="ico" title={t("Delete", "删除")} onClick={() => del(x)}>✕</button></td>
            </tr>
          ))}
        </tbody></table>}
      </div>
      <div className="mb"><button className="btn" onClick={closeModal}>{t("Close", "关闭")}</button></div>
    </Modal>
  );
}
